// extracted by mini-css-extract-plugin
export default {"button":"Collapsible-button_TRwgx"};